import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const ShintaiKbn = props => {
  return <Dropdown.Static kubunKey='shintai_kbn' {...props} />
}
